"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var log = _interopRequireWildcard(require("loglevel"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Global logger class
 */
var WDHLogger =
/*#__PURE__*/
function () {
  function WDHLogger() {
    _classCallCheck(this, WDHLogger);
  }

  _createClass(WDHLogger, null, [{
    key: "enable",

    /**
    * Enables logging
    */
    value: function enable() {
      log.enableAll();
    }
    /**
    * Disables logging
    */

  }, {
    key: "disable",
    value: function disable() {
      log.disableAll();
    }
    /**
    * Logs message at info level
    * @param {string} message
    */

  }, {
    key: "info",
    value: function info(message) {
      log.info("[INFO] - ".concat(message));
    }
    /**
    * Logs message at warn level
    * @param {string} message
    */

  }, {
    key: "warn",
    value: function warn(message) {
      log.warn("[WARN] - ".concat(message));
    }
    /**
    * Logs message at trace level
    * @param {string} message
    */

  }, {
    key: "trace",
    value: function trace(message) {
      log.trace("[TRACE] - ".concat(message));
    }
    /**
    * Logs message at error level
    * @param {string} message
    */

  }, {
    key: "error",
    value: function error(message) {
      log.error("[ERROR] - ".concat(message));
    }
  }]);

  return WDHLogger;
}();

var _default = WDHLogger;
exports["default"] = _default;